import { Injectable } from "@angular/core";
import { Observable, Subject, forkJoin } from "rxjs";
import { EncounterValue, Appointment, Admission } from "@shared/entities";
import { ObEncounter } from "@shared/models/ob-encounter.model";
import { PEncounter } from "@shared/models/pediatric-encounter.model";
import { ApiResources } from "../helpers";
import { HttpService, NotifyService } from "@shared/services";
import { OB } from "@admin/full-transcript/pages/ob-report/ob.namespace";
import { GynEncounter } from "../models/gyn-encounter.model";
import { EmergencyEncounter } from "../models";
import { DietEncounter } from "../models/diet-encounter.model";
import { GYN } from "../../areas/admin/gyn-encounter/gyn.namespace";
import { GeneticSpecialityEncounter } from "../enums/genetic-speciality-encounter-type";
 
 

import { PhysiotherapyEncounterList } from "../entities/physiotherapy-encounter.entity";
import { NeonatalEncounterType } from "../enums/neonatal-encounter-type.enum";
import { IvfEncounter } from "../models/ivf-encounter.model";
import { NurseAssessementResources } from "../models/nurse-assessment-resources";

@Injectable()
export class EncounterCommunication {

    isAdmission: boolean;
    encounterDashboard: EncounterValue;
    ancCardDetais: OB.AncCardGeneration;
    isANC: boolean;
    gynEncounterDashboard: EncounterValue;
    pencounterDashboard: EncounterValue;
    geneticencounterDashboard: EncounterValue;
    neonatalEncounterDashboard: EncounterValue;
    emergencyEncounterDashboard: EncounterValue;
    dietEncouterDashboard: EncounterValue;
    ivfEncouterDashboard: EncounterValue;
    obEncounter: ObEncounter;
    measures: OB.Measure;
    isAncCrad: boolean;
    isGynCard: boolean;
    gynEncounters: GynEncounter;
    gynCardDetails: GYN.GynCard;
    constructor(

        private readonly httpService: HttpService,
        private readonly notifyService: NotifyService,
    ) { }
    private encounterSource = new Subject();
    private gynEncounterSource = new Subject();
    private pencounterSource = new Subject();
    private emergencyEncounterSource = new Subject();
    private dietEncounterSource = new Subject();
    private geneticEncounterSource = new Subject();
    private physionTherapySource = new Subject();
    private neonatalipEncounterSource = new Subject();
    private ivfEncounterSource = new Subject();

    encounter: Observable<any> = this.encounterSource.asObservable();
    gynEncounter: Observable<any> = this.gynEncounterSource.asObservable();
    pEncounter: Observable<any> = this.pencounterSource.asObservable();
    emergencyEncounter: Observable<any> = this.emergencyEncounterSource.asObservable();
    dietEncounter: Observable<any> = this.dietEncounterSource.asObservable();
    geneticEncounter: Observable<any> = this.geneticEncounterSource.asObservable();
    physionTherapyEncounter: Observable<any> = this.physionTherapySource.asObservable();
    neonatalipEncounter: Observable<any> = this.neonatalipEncounterSource.asObservable();
    ivfEncounter: Observable<any> = this.ivfEncounterSource.asObservable();


    setEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[ObEncounter]>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), request)
                .subscribe((response: [ObEncounter]) => {
                    this.encounterDashboard = new EncounterValue();
                    this.encounterDashboard.value = response["dashboard"];
                    this.encounterSource.next(this.encounterDashboard);
                });

        }
        else {
            value.isSubmitandNext = false;
            this.encounterSource.next(value);
        }

    }
    gynSetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[GynEncounter]>(ApiResources.getURI(ApiResources.gynEncounter.base, ApiResources.gynEncounter.findData), request)
                .subscribe((response: [GynEncounter]) => {
                    this.gynEncounterDashboard = new EncounterValue();
                    this.gynEncounterDashboard.value = response["dashboard"];
                    this.gynEncounterSource.next(this.gynEncounterDashboard);
                });
        }
        else {
            value.isSubmitandNext = false;
            this.gynEncounterSource.next(value);
        }

    }

    dietSetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[DietEncounter]>(ApiResources.getURI(ApiResources.dietEncounter.base, ApiResources.dietEncounter.find), request)
                .subscribe((response: [DietEncounter]) => {
                    this.dietEncouterDashboard = new EncounterValue();
                    this.dietEncouterDashboard.value = response["dashboard"];
                    this.dietEncounterSource.next(this.dietEncouterDashboard);
                });
        }
        else {
            this.dietEncounterSource.next(value);
        }

    }

    psetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[PEncounter]>(ApiResources.getURI(ApiResources.pediatricEncounter.base, ApiResources.pediatricEncounter.findData), request)
                .subscribe((response: [PEncounter]) => {
                    this.pencounterDashboard = new EncounterValue();
                    this.pencounterDashboard.value = response["dashboard"];
                    this.pencounterSource.next(this.pencounterDashboard);
                });

        }
        else {
            this.pencounterSource.next(value);
        }

    }
    geneticspecialityEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[GeneticSpecialityEncounter]>(ApiResources.getURI(ApiResources.geneticSpecialityEncounter.base, ApiResources.geneticSpecialityEncounter.findDashboard), request)
                .subscribe((response: [GeneticSpecialityEncounter]) => {
                    this.geneticencounterDashboard = new EncounterValue();
                    this.geneticencounterDashboard.value = response;
                    this.geneticEncounterSource.next(this.geneticencounterDashboard);
                });

        }
        else {
            this.geneticEncounterSource.next(value);
        }

    }
    neonatalsetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[NeonatalEncounterType]>(ApiResources.getURI(ApiResources.neonatalEncounter.base, ApiResources.neonatalEncounter.findDashboard), request)
                .subscribe((response: [NeonatalEncounterType]) => {
                    this.neonatalEncounterDashboard = new EncounterValue();
                    this.neonatalEncounterDashboard.value = response;
                    this.neonatalipEncounterSource.next(this.neonatalEncounterDashboard);
                });

        }
        else {
            this.neonatalipEncounterSource.next(value);
        }   
    }
   ivfSetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[IvfEncounter]>(ApiResources.getURI(ApiResources.ivfEncounter.base, ApiResources.ivfEncounter.find), request)
                .subscribe((response: [IvfEncounter]) => {
                    this.ivfEncouterDashboard = new EncounterValue();
                    this.ivfEncouterDashboard.value = response["dashboard"];
                    this.ivfEncounterSource.next(this.ivfEncouterDashboard);
                });
        }
        else {
            this.ivfEncounterSource.next(value);
        }

    }

    private encounterComplete = new Subject();
    encounterComplets: Observable<any> = this.encounterComplete.asObservable();
    modifyEncounterStatus(appointmentId: number) {
        this.httpService
            .get<[ObEncounter]>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.completedEncounter), { appointmentId: appointmentId })
            .subscribe((response: [any]) => {
                this.encounterComplete.next(true);
                $("#printButton").click();
            });
    }
    private gynEncounterComplete = new Subject();
    gynEncounterComplets: Observable<any> = this.gynEncounterComplete.asObservable();
    modifyGynEncounterStatus(appointmentId: number) {
        this.httpService
            .get<[GynEncounter]>(ApiResources.getURI(ApiResources.gynEncounter.base, ApiResources.gynEncounter.encounterComplete), { appointmentId: appointmentId })
            .subscribe((response: [any]) => {
                this.gynEncounterComplete.next(true);
                $("#printButton").click();
                
            });
    }

    private pencounterComplete = new Subject();
    pencounterComplets: Observable<any> = this.pencounterComplete.asObservable();
    modifyPEncounterStatus(appointmentId: number) {
        this.httpService
            .get<[PEncounter]>(ApiResources.getURI(ApiResources.pediatricEncounter.base, ApiResources.pediatricEncounter.encounterCompleted), { appointmentId: appointmentId })
            .subscribe((response: [any]) => {
                this.pencounterComplete.next(true);
                $("#printButton").click();
            });
    }

    private dietencounterComplete = new Subject();
    dietencounterCompletes: Observable<any> = this.dietencounterComplete.asObservable();
    modifyDietEncounterStatus(appointmentId: number) {
        this.httpService
            .get<[ObEncounter]>(ApiResources.getURI(ApiResources.dietEncounter.base, ApiResources.dietEncounter.completedEncounter), { appointmentId: appointmentId })
            .subscribe((response: [any]) => {
                this.dietencounterComplete.next(true);
                $("#printButton").click();
            });
    }

    //private ivfEncounterComplete = new Subject();
    //ivfEncounterComplets: Observable<any> = this.gynEncounterComplete.asObservable();
    //modifyIVFEncounterStatus(appointmentId: number) {
    //    this.httpService
    //        .get<[IvfEncounter]>(ApiResources.getURI(ApiResources.ivfEncounter.base, ApiResources.ivfEncounter.encounterComplete), { appointmentId: appointmentId })
    //        .subscribe((response: [any]) => {
    //            this.ivfEncounterComplete.next(true);
    //            $("#printButton").click();

    //        });
    //}
    findANCCard(patientId: number, appointmentId: number, encounterType: string) {
        if (encounterType === 'ob-encounter') {
            const request = {
                patientId: patientId,
                appointmentId: appointmentId
            }
            this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchANC), request)
                .subscribe((response: OB.AncCardGeneration) => {
                    if (response && response.ancNo == null) {
                        this.notifyService.warning("Please Generate ANC Card");
                    }
                    this.ancCardDetais = response;
                    if (this.ancCardDetais && this.ancCardDetais.ancNo == null) {
                        return true;
                    }
                    else {
                        return false
                    }
                });
        }
        if (encounterType === 'gyn-encounter') {
            const request = {
                patientId: patientId,
                appointmentId: appointmentId
            }
            this.httpService.get(ApiResources.getURI(ApiResources.gynEncounter.base, ApiResources.gynEncounter.fetchGynCard), request)
                .subscribe((response: GYN.GynCard) => {
                    if (response == null) {
                        //this.gynCardDetails = response;
                        //if (this.gynCardDetails && this.gynCardDetails.gynNo == null) {
                            this.isGynCard = true;
                            this.notifyService.warning("Please Generate gyn Card");
                            return true;
                       // }

                    }
                       ////else if (this.gynCardDetails  == null) {
                       ////     this.isGynCard = true;
                       ////     this.notifyService.warning("Please Generate gyn Card");
                       ////     return true;
                       //// }
                    else {
                        this.gynCardDetails = response;
                        
                            this.isGynCard = false;
                            return false
                        }                 
                   

                });
        }
        return this.isGynCard;
        
    

        
    }

    findAppointment(appointmentId: string, type: string, isAdmission?: boolean) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = isAdmission != null ? isAdmission : this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .subscribe((response: Appointment) => {
                if (response) {
                    if (type === 'ob-encounter') {
                        this.checkAncCondition(response.patientId, response.appointmentId, appointmentId, false);
                    }
                    else {
                        this.isANC = this.findANCCard(response.patientId, response.appointmentId, type);
                    }
                    
                }
            });
        return this.isANC;
    }
    findAdmission(appointmentId: string, type: string) {
        const request = {
            encryptedAdmissionId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.get(ApiResources.getURI(ApiResources.admissions.base, ApiResources.admissions.find), request)
            .subscribe((response: Admission) => {
                if (response) {
                    if (type === 'ob-encounter' || type === 'ob-ip-encounter') {
                        this.checkAncCondition(response.patientId, response.admissionId, appointmentId, true);
                    }
                }
            });
        return this.isANC;
    }

    checkAncCondition(patientId: number, appointmentId: number, encryptedAppointmentId?: string, isAdmission?: boolean) {
        const request = { patientId: patientId, appointmentId: appointmentId, isAdmission: isAdmission }
            let ancCard = this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchANC), request)
        let dashboard = this.httpService.post<[ObEncounter]>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), { encryptedAppointmentId: encryptedAppointmentId })
            forkJoin([ancCard, dashboard])
                .subscribe((response: Array<any>) => {
                    this.ancCardDetais = response[0] as OB.AncCardGeneration;
                    var values = response[1] as ObEncounter;
                    this.obEncounter = values["dashboard"];
                    if (this.obEncounter && this.obEncounter.measure) {
                        this.measures = JSON.parse(this.obEncounter.measure);
                        if (this.measures.department == "Prepregnancy counselling" || this.measures.department == "Postnatal") {
                            this.isAncCrad = false;
                        }
                        else if (this.ancCardDetais && this.ancCardDetais.ancNo == null) {
                            this.notifyService.warning("Please generate anc card");
                            this.isAncCrad = true;
                        }
                        else if (this.ancCardDetais == null) {
                            this.notifyService.warning("Please generate anc card");
                            this.isAncCrad = true;
                        }
                        else {
                            this.isAncCrad = false;
                        }
                    }
                    else if (this.ancCardDetais == null) {
                        this.notifyService.warning("Please generate anc card");
                        this.isAncCrad = true;
                    }
                    else if (this.ancCardDetais && this.ancCardDetais.ancNo == null) {
                        this.notifyService.warning("Please generate anc card");
                        this.isAncCrad = true;
                    }
                    else {
                        this.isAncCrad = false;
                    }
                });
                
    }

    checkGynCardCondition(patientId: number, appointmentId: number) {
        const request = {
            patientId: patientId,
            appointmentId: appointmentId
        }
        this.httpService.get(ApiResources.getURI(ApiResources.gynEncounter.base, ApiResources.gynEncounter.fetchGynCard), request)
            .subscribe((response: GYN.GynCard) => {
                this.gynCardDetails = response;
                if (response == null) {
                    this.isGynCard = true;
                    this.notifyService.warning("Please Generate gyn Card");
                    return;
                }
                else {
                    this.isGynCard = false;
                }
            });                    
                    //if (this.gynCardDetails && this.gynCardDetails.gynNo == null) {
                    //    this.notifyService.warning("Please generate gyn card");
                    //    this.isGynCard = true;
                    //    return;
                    //}
                    //else if (this.gynCardDetails == null) {
                    //    this.notifyService.warning("Please generate gyn card");
                    //    this.isGynCard = true;
                    //    return;
                    //}
                    //else {
                    //    this.isGynCard = false;
                    //}
                }
    emergencysetEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[EmergencyEncounter]>(ApiResources.getURI(ApiResources.emergencyEncounter.base, ApiResources.emergencyEncounter.find), request)
                .subscribe((response: [EmergencyEncounter]) => {
                    this.emergencyEncounterDashboard = new EncounterValue();
                    this.emergencyEncounterDashboard.value = response["dashboard"];
                    this.emergencyEncounterSource.next(this.emergencyEncounterDashboard);
                });

        }
        else {
            this.emergencyEncounterSource.next(value);
        }

    }


    physioTherapyEncounter(value: EncounterValue) {
        if (value.isSubmitandNext) {
            const request = { encryptedAppointmentId: value.encryptedAppointmentId };
            request["isAdmission"] = value.isAdmission;
            this.httpService
                .post<[PhysiotherapyEncounterList]>(ApiResources.getURI(ApiResources.physiotherapyEncounter.base, ApiResources.physiotherapyEncounter.fetch), request)
                .subscribe((response: [PhysiotherapyEncounterList]) => {
                    this.encounterDashboard = new EncounterValue();
                    this.encounterDashboard.value = response;
                    this.physionTherapySource.next(this.encounterDashboard);
                });

        }
        else {
            value.isSubmitandNext = false;
            this.physionTherapySource.next(value);
        }

    }

    private nurseAssessmentSource = new Subject();
    nurseForms: Observable<any> = this.nurseAssessmentSource.asObservable();
    nurseAssessment(value: NurseAssessementResources) {
        const request = { encryptedAdmissionId: value.encryptedAdmissionId };
        this.httpService
            .post < Array<NurseAssessementResources>>(ApiResources.getURI(ApiResources.nurseAssessmentForms.base, ApiResources.nurseAssessmentForms.findAll), request)
            .subscribe((response: Array<NurseAssessementResources>) => {
                var records = response;
                this.nurseAssessmentSource.next(records);
                });
    }
}